import { HttpErrorResponse } from '@angular/common/http';

export enum RecaptchaAction {
  register = 'register',
  login = 'login',
}

export interface RecaptchaData {
  token: string;
  apiKey: string;
}

const RECAPTCHA_TOKEN_HEADER = 'x-pw-cap-token';
const RECAPTCHA_KEY_HEADER = 'x-pw-cap-key';
export const createRecaptchaHeaders = (data: RecaptchaData): { [headerName: string]: string } => ({
  [RECAPTCHA_KEY_HEADER]: data.apiKey,
  [RECAPTCHA_TOKEN_HEADER]: data.token,
});
const TOO_LOW_SCORE_MESSAGE = 'Forbidden activity detected';
const isCaptchaTooLowScoreResponse = (response: HttpErrorResponse): boolean =>
  response.status === 403
  && response.error?.error === TOO_LOW_SCORE_MESSAGE;

export const isRecaptchaTooLowScoreHttpResponse = (error: unknown): boolean =>
  error instanceof HttpErrorResponse
  && isCaptchaTooLowScoreResponse(error);

export class TooLowRecaptchaScoreError extends Error {
  constructor() {super('Too low recaptcha score');}
}
